<template>
	<div class="w1200 flex flex-direction flex-wrap align-center benben-flex-layout orderPlaced">
	    <img class="orderPlaced_1" src="https://api.ezlunch.club/pc/image/28.png" alt="" srcset="">
	    <div class="orderPlaced_2">{{$t('下单成功')}}</div>
		<div class="orderPlaced_3 pointer" @click="tiaozhuan(1)">{{$t('查看预约')}}</div>
		<div class="orderPlaced_4 pointer" @click="tiaozhuan(2)">{{$t('返回首页')}}</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
			}else{
				this.$router.push({
					name: 'login',
				});
			}
		},

		methods: {
			gengxin(){
				
			},
			tiaozhuan(type){
				let url = ''
				if(type == 1){
					url = 'appointment'
				}else if(type == 2){
					url = 'menu'
				}
				this.$router.replace({
					name: url,
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {}
	.orderPlaced{
		background: #fff;
		padding: 220px 0;
		margin-top: 20px;
	}
	.orderPlaced_1{
		width: 88px;
		height: 88px;
	}
	.orderPlaced_2{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		margin: 14px 0 0 0;
	}
	.orderPlaced_3{
		min-width: 140px;
		height: 42px;
		background: #FF8A24;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 42px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		margin: 56px 0 24px 0;
	}
	.orderPlaced_4{
		min-width: 140px;
		height: 42px;
		background: #fff;
		border: 1px solid #FF8A24;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 42px;
		font-weight: 400;
		font-size: 16px;
		color: #FF8A24;
	}
</style>